module.exports = __webpack_public_path__ + "static/media/modal-close-hover.d8c9109d.svg";